export async function parseRelayerJson(
  response: Response,
  fallbackMessage: string
): Promise<any> {
  const contentType = response.headers.get("content-type") || "";
  const text = await response.text().catch(() => "");
  const trimmed = text.trim();

  if (
    contentType.includes("application/json") ||
    trimmed.startsWith("{") ||
    trimmed.startsWith("[")
  ) {
    try {
      return trimmed ? JSON.parse(trimmed) : {};
    } catch {
      throw new Error(`${fallbackMessage} The relayer returned malformed JSON.`);
    }
  }

  if (contentType.includes("text/html") || /^<!doctype|^<html/i.test(trimmed)) {
    throw new Error(
      `${fallbackMessage} The relayer endpoint returned the web app instead of JSON.`
    );
  }

  throw new Error(`${fallbackMessage} The relayer returned an invalid response.`);
}

export async function fetchRelayerNonce(
  relayer: string,
  address: string,
  router: string,
  fallbackMessage = "Could not reach the relayer."
): Promise<string> {
  const response = await fetch(`${relayer}/nonce/${address}?router=${router}`);
  const json = await parseRelayerJson(response, fallbackMessage);

  if (!response.ok) {
    throw new Error(json?.error || json?.message || fallbackMessage);
  }
  if (json?.nonce === undefined || json?.nonce === null) {
    throw new Error("Relayer did not return a nonce.");
  }

  return String(json.nonce);
}
